import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  listLoading: false,
  listLoaded: false,
  itemsLoading: false,
  itemsLoaded: false,
  popularItems: {},
  popularList: {},
  listError: null,
  itemsError: null,
});

const { Types, Creators } = createActions({
  getPopularItems:              null,
  getPopularItemsConnected:     ['popularItems'],
  getPopularItemsError:         ['error'],
  getPopularItemsDisconnected:  null,

  getPopularList:              null,
  getPopularListConnected:     ['popularList'],
  getPopularListError:         ['error'],
  getPopularListDisconnected:  null,
});

export const getPopularItemsReducer = ( state ) =>
  state.set('itemsLoading', true)

export const getPopularItemsConnectedReducer = ( state, { popularItems } ) =>
  state.set('popularItems', popularItems)
       .set('itemsLoading', false)
       .set('itemsLoaded', true)

export const getPopularItemsDisconnectedReducer = ( state ) =>
  state.set('itemsLoading', false)

export const getPopularItemsErrorReducer = ( state, { error } ) =>
  state.set('itemsError', error)
       .set('itemsLoading', false)

export const getPopularListReducer = ( state ) =>
  state.set('listLoading', true)

export const getPopularListConnectedReducer = ( state, { popularList } ) =>
  state.set('popularList', popularList)
       .set('listLoading', false)
       .set('listLoaded', true)

export const getPopularListDisconnectedReducer = ( state ) =>
  state.set('listLoading', false)

export const getPopularListErrorReducer = ( state, { error } ) =>
  state.set('listError', error)
       .set('listLoading', false)

export const popularReducer = createReducer(INITIAL_STATE, {
  [Types.GET_POPULAR_ITEMS]:              getPopularItemsReducer,
  [Types.GET_POPULAR_ITEMS_CONNECTED]:    getPopularItemsConnectedReducer,
  [Types.GET_POPULAR_ITEMS_DISCONNECTED]: getPopularItemsDisconnectedReducer,
  [Types.GET_POPULAR_ITEMS_ERROR]:        getPopularItemsErrorReducer,

  [Types.GET_POPULAR_LIST]:              getPopularListReducer,
  [Types.GET_POPULAR_LIST_CONNECTED]:    getPopularListConnectedReducer,
  [Types.GET_POPULAR_LIST_DISCONNECTED]: getPopularListDisconnectedReducer,
  [Types.GET_POPULAR_LIST_ERROR]:        getPopularListErrorReducer,
})


export const PopularTypes = Types
export default Creators;



// WEBPACK FOOTER //
// ./src/reducers/popularReducer.js